namespace Matrix.Data {
    export interface AccountModelTargetDeleteAllRequest extends Serenity.ServiceRequest {
        ModelCode?: string;
        AccountCode?: string;
    }
}
